// extracted by mini-css-extract-plugin
export default {"image":"BigImage_image__HpztB"};